import { JobCard } from 'components/JobCard';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { MetaDataSelector, jobListSelector } from 'redux/features/jobList';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { createDefaultLinkForJobDetail } from 'components/JobCard/logics/createDefaultLinkForJobDetail';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { Pager } from '@doda/io-react/pc';
import { usePager } from 'hooks/usePager';
import { NoResult } from 'components/NoResult';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import styles from './index.module.scss';
import {
  measureOnClickAgentApply,
  measureOnClickApply,
  measureOnClickBookmark,
} from '../../logics/careerRecommendJobListAnalytics';

/**
 * Propsの型定義
 * @param currentPage
 * @param maxPage
 */
interface Props {
  currentPage: number;
  maxPage: number;
}

export const JobList: React.FC<Props> = ({ currentPage, maxPage }) => {
  const { pic = '1' } = useAppSelector(appQueryParamsSelector);
  const isNoPic = pic === '0';
  const jobList = useAppSelector(jobListSelector);
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  const dispatch = useAppDispatch();
  const jobListMeta = useAppSelector(MetaDataSelector);
  const { createPageHref } = usePager({
    totalCount: jobListMeta?.totalCount,
    currentPage,
  });

  if (jobListMeta?.totalCount === 0)
    return <NoResult href={DODA_SITE_URL.jobSearchTop} />;

  return (
    <>
      <div className={styles.careerRecommendJobList__jobList}>
        {jobList?.map((job, index) => {
          const destinationURL = createDefaultLinkForJobDetail(
            job.jid ?? '',
            job.isRead ?? false
          );
          const jid = {
            jid: job.jid,
          };
          return (
            <div
              className={styles.careerRecommendJobList__jobCardWrapper}
              key={job.jid}
            >
              <JobCard
                job={job}
                isNoPic={isNoPic}
                destinationURL={destinationURL}
                onApplyDirect={() =>
                  measureOnClickApply(isAdobeScript, dispatch, jid)
                }
                onApplyAgent={() =>
                  measureOnClickAgentApply(isAdobeScript, dispatch, jid)
                }
                onBookmark={() =>
                  measureOnClickBookmark(isAdobeScript, dispatch, jid)
                }
                imagePriority={index === 0}
              />
            </div>
          );
        })}
      </div>
      <div className={styles.careerRecommendJobList__pagination}>
        <Pager
          maxPage={maxPage}
          currentPage={currentPage}
          createPageHref={createPageHref}
        />
      </div>
    </>
  );
};
